document.querySelectorAll('.textarea-with-counter').forEach((textarea) => {
  const parent = textarea.closest('.mod-input');
  const counter = parent?.querySelector('.mod-input__curr-character');
  const textareaInput = parent?.querySelector('textarea');
  if (!counter || !textareaInput) return; // safety check

  // Remove empty space for default value
  textareaInput.value = textareaInput.value.trim();

  const updateCount = (ele) => {
    const value = ele ? ele.target.value : textareaInput.value;
    counter.textContent = value.length;
  };

  updateCount();
  textarea.addEventListener('input', updateCount);
});

// *******************************************************************************
// Letters and numbers validation
// *******************************************************************************
const onlyLettersInputs = document.querySelectorAll('[data-letters-only]');

onlyLettersInputs.forEach((input) => {
  input.addEventListener('input', (event) => {
    const inputValue = event.target.value;
    event.target.value = inputValue.replace(/[^a-zA-ZčČšŠžŽđĐćĆ\s]/g, '');
  });
});

const numbersFields1 = document.querySelectorAll('[data-num]');
const numbersFields2 = document.querySelectorAll('input[type="number"]');
const numbersFields = [...numbersFields1, ...numbersFields2];

numbersFields.forEach((input) => {
  input.addEventListener('input', (event) => {
    const inputValue = event.target.value;
    event.target.value = inputValue.replace(/(?!^\+)\D/g, '');
  });
});
